//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { recognition } from 'mycorems-app-accounts';
import isGranted from '@/auth/isGranted';
import Header from './Header.vue';
import Sidebar from './Sidebar.vue';

export default {
  name: 'App',
  data() {
    return {
      leftDrawerOpen: false,
    };
  },
  methods: {
    isGranted,
  },
  created() {
    if (!recognition.isAuthenticated()) {
      this.$router.push('/login?redirect=true');
    }
  },
  components: {
    'app-header': Header,
    sidebar: Sidebar,
  },
};
